import styled from 'styled-components';

export const AddButtonWrapper = styled.div.attrs({ className: 'hl3' })`
  margin-top: 30px;
  padding: 15px;
  width: 100%;
  background-color: ${({ theme }) => theme.white.a10};
  display: flex;
  justify-content: center;
  border-radius: 5px;
  border: dashed 1px ${({ theme }) => theme.baseBlue.a10};
  box-shadow: 0 4px 14px 0 rgba(78, 84, 107, 0.05);
  cursor: pointer;
  position: relative;
  &:hover {
    box-shadow: 0 7px 20px 0 rgba(78, 84, 107, 0.1);
  }
`;
